import React from 'react';
import './App.css';

function Footer() {
  return (
        <>
          <footer>
            <div className="footer-content">
              <p>&copy; 2024 Sasuvika Consultancy Inc. All rights reserved. </p>
              <div className="social-icons">
              </div>
            </div>
          </footer>
        </>
  );
}

export default Footer;
